// "Grade 5" for a single grade, "Grades 3-4" for a range. Numeric codes drop
// their zero-padding; EE/PK/KG pass through as-is.
export const formatGrade = (grade) => {
  const n = parseInt(grade, 10);
  return Number.isNaN(n) ? String(grade) : String(n);
};

export const gradeSpanLabel = (gradeStart, gradeEnd) => {
  if (gradeStart == null || gradeStart === '' || gradeEnd == null || gradeEnd === '') return '';
  const low = formatGrade(gradeStart);
  const high = formatGrade(gradeEnd);
  return low === high ? `Grade ${low}` : `Grades ${low}-${high}`;
};

// Backend span strings are padded code pairs like "03-08".
export const spanStringLabel = (span) => {
  if (!span || typeof span !== 'string' || !span.includes('-')) return '';
  const [low, high] = span.split('-');
  return gradeSpanLabel(low, high);
};
